import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
export default function Countdown({ target }) {
    const [now, setNow] = useState(() => new Date());
    useEffect(() => {
        const t = setInterval(() => setNow(new Date()), 1000);
        return () => clearInterval(t);
    }, []);
    const diff = Math.max(0, target.getTime() - now.getTime());
    const d = Math.floor(diff / 86_400_000);
    const h = Math.floor((diff % 86_400_000) / 3_600_000);
    const m = Math.floor((diff % 3_600_000) / 60_000);
    const s = Math.floor((diff % 60_000) / 1000);
    const Pod = ({ n, l }) => (_jsxs("div", { className: "bg-white/20 backdrop-blur border border-white/25 rounded-2xl px-3 sm:px-4 py-2.5 min-w-[64px] sm:min-w-[78px] text-center shadow-sm", children: [_jsx("div", { className: "font-serif text-2xl sm:text-3xl font-bold leading-none tabular-nums", children: n }), _jsx("div", { className: "text-[10px] uppercase tracking-[.2em] opacity-90 mt-1", children: l })] }));
    return (_jsxs("div", { className: "flex gap-2 flex-wrap", role: "timer", "aria-label": "Countdown to party", children: [_jsx(Pod, { n: d, l: "Days" }), _jsx(Pod, { n: String(h).padStart(2, "0"), l: "Hours" }), _jsx(Pod, { n: String(m).padStart(2, "0"), l: "Min" }), _jsx(Pod, { n: String(s).padStart(2, "0"), l: "Sec" })] }));
}
